import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export interface IRTBloggerStateSlice {
  onGoingRTAR: {
    rtar: Omit<IPostParseRTARResponse, "patient_status">;
    billing: IPostRTARBillingResponse[];
    billingOverview: IGetOverviewPatientsResponse["billing_overview"];
    state: "pending" | "completed" | "skip";
  }[];
  billingSettings: IGetBillingSettingsResponse[];
  auditSettings: IGetAuditResponse[];
  cptTypes: IGetCPTTypesResponse[];
}

const name = "rtBlogger";

export const initialState: IRTBloggerStateSlice = {
  onGoingRTAR: [],
  billingSettings: [],
  auditSettings: [],
  cptTypes: [],
};

export const rtBloggerSlice = createSlice({
  name,
  initialState,
  reducers: {
    setOnGoingRTAR(
      state,
      action: PayloadAction<IRTBloggerStateSlice["onGoingRTAR"]>
    ) {
      state.onGoingRTAR = action.payload;
    },
    setAddRTAR(
      state,
      action: PayloadAction<{
        rtar: Omit<IPostParseRTARResponse, "patient_status">;
        billing: IPostRTARBillingResponse[];
        billingOverview: IGetOverviewPatientsResponse["billing_overview"];
      }>
    ) {
      state.onGoingRTAR.push({
        rtar: action.payload.rtar,
        billing: action.payload.billing,
        billingOverview: action.payload.billingOverview,
        state: "pending",
      });
    },
    setAllOnGoingRTARStatus(
      state,
      action: PayloadAction<{
        status: "pending" | "completed" | "skip";
      }>
    ) {
      state.onGoingRTAR = state.onGoingRTAR.map((item) => {
        return { ...item, state: action.payload.status };
      });
    },
    setEditRTAR(
      state,
      action: PayloadAction<{
        rtar?: Omit<IPostParseRTARResponse, "patient_status">;
        billing?: IPostRTARBillingResponse[];
        billingOverview?: IGetOverviewPatientsResponse["billing_overview"];
        state?: "pending" | "completed" | "skip";
        index?: number;
      }>
    ) {
      const index =
        action.payload.index !== undefined
          ? action.payload.index
          : state.onGoingRTAR.findIndex(
              (item) =>
                item.rtar?.patient.id === action.payload.rtar?.patient.id
            );
      if (index !== -1) {
        const currentItem = state.onGoingRTAR[index];
        state.onGoingRTAR[index] = {
          rtar: action.payload.rtar || currentItem.rtar,
          billing: action.payload.billing || currentItem.billing,
          billingOverview:
            action.payload.billingOverview || currentItem.billingOverview,
          state: action.payload.state || currentItem.state,
        };
      }
    },
    setBillingSettings(
      state,
      action: PayloadAction<IRTBloggerStateSlice["billingSettings"]>
    ) {
      state.billingSettings = action.payload;
    },
    setAuditSettings(
      state,
      action: PayloadAction<IRTBloggerStateSlice["auditSettings"]>
    ) {
      state.auditSettings = action.payload;
    },
    setCPTTypes(
      state,
      action: PayloadAction<IRTBloggerStateSlice["cptTypes"]>
    ) {
      state.cptTypes = action.payload;
    },
  },
});

export const {
  setOnGoingRTAR,
  setAddRTAR,
  setEditRTAR,
  setAllOnGoingRTARStatus,
  setBillingSettings,
  setAuditSettings,
  setCPTTypes,
} = rtBloggerSlice.actions;

const persistedReducer = persistReducer(
  {
    key: name,
    storage: storage,
    whitelist: [],
  },
  rtBloggerSlice.reducer
);

export default persistedReducer;
